import dynamic from "next/dynamic";
const ParallaxVideoAssetComponent = dynamic(()=>import("segments/desktop/asset/layouts/parallax-video-asset/parallax-video-asset-component"));
import ParallaxVideoAssetConfig from "./parallax-video-asset-config";
import ParallaxVideoAssetAdvancedConfig from "./parallax-video-asset-advanced-config";
export default {
    ParallaxVideoAssetComponent,
    ParallaxVideoAssetConfig,
    ParallaxVideoAssetAdvancedConfig
};
